import { CustomUnitIndex } from "../views";

export const customUnitRouter = [
  {
    name: "CustomUnitIndex",
    component: CustomUnitIndex,
    path: "/custom-unit"
  }
];
